@if (error) {
  <div class="error-banner" role="alert" aria-live="polite">
    <mat-icon class="error-banner__icon" aria-hidden="true">error_outline</mat-icon>
    <div class="error-banner__message">{{ error.message }}</div>
  </div>
}

<div class="details-content" [class.details-content--gost]="recordtype == 7">
  @if (isLoadingRecord) {
    <div class="loading-skeletons protocol-rsst" role="status" aria-live="polite" aria-busy="true">
      <div class="protocol-rsst__header">
        <div class="skeleton-title"></div>
        <div class="skeleton-chip-row">
          <span class="skeleton-chip"></span>
          <span class="skeleton-chip"></span>
          <span class="skeleton-chip"></span>
        </div>
      </div>
      <div class="protocol-rsst__body">
        <div class="rsst-skeleton-kpi-row">
          <div class="rsst-skeleton-kpi">
            <div class="skeleton-line short"></div>
            <div class="skeleton-line"></div>
          </div>
          <div class="rsst-skeleton-kpi">
            <div class="skeleton-line short"></div>
            <div class="skeleton-line"></div>
          </div>
          <div class="rsst-skeleton-kpi">
            <div class="skeleton-line short"></div>
            <div class="skeleton-line"></div>
          </div>
        </div>
        <div class="rsst-skeleton-timeline">
          <div class="skeleton-title"></div>
          <div class="skeleton-wave"></div>
          <div class="skeleton-line"></div>
          <div class="skeleton-line short"></div>
        </div>
      </div>
    </div>
  }

  @if (recordtype >= 0 && recordData?.id !== 'new_gost' && recordData && !(recordtype == 0 && showRsstChart) && !showMwstView && !showMonitoringView && !(recordtype == 4 || recordData?.data?.recordType === 'VS') && recordtype !== 5 && recordtype !== 6 && recordtype !== 7) {
    <app-measured-data-summary-card
      [recordData]="this.recordData"
      [recordtype]="recordtype"
      [hideCoughCountBefore]="'2025-04-01'"
      (sectionRequested)="scrollToGostSection($event)">
    </app-measured-data-summary-card>
  }

  @if (recordtype == 7 && this.recordData && recordData?.data?.gostOCData && recordData?.data?.gostGCData && recordData?.data?.gostSCData) {
    <gost-infos-card
      #gost_infos_card
      [recordData]="this.recordData"
      [recordDataUpdated]="this.recordDataUpdated"
      [afterScTemplate]="showWaveCard ? gostTimelineTpl : null">
    </gost-infos-card>
  }

  <ng-template #gostTimelineTpl>
    <div class="gost-timeline-card" [class.gost-timeline-card--collapsed]="!gostTimelineExpanded">
      <button
        type="button"
        class="gost-timeline-card__header gost-timeline-card__header--toggle"
        (click)="gostTimelineExpanded = !gostTimelineExpanded"
        [attr.aria-expanded]="gostTimelineExpanded"
        aria-controls="gost-timeline-content">
        <div class="gost-timeline-card__header-left">
          <mat-icon class="gost-timeline-card__icon">graphic_eq</mat-icon>
          <span class="gost-timeline-card__title">
            <span class="gost-timeline-card__title-main" i18n="@@home.measuredDataDetails.timeline.title">波形タイムライン</span>
            <span class="gost-timeline-card__title-detail" i18n="@@home.measuredDataDetails.timeline.subtitle"> — 波形・姿勢・イベント</span>
          </span>
        </div>
        <div class="gost-timeline-card__header-right">
          <span class="gost-timeline-card__duration">
            <span i18n="@@home.measuredDataDetails.timeline.duration">録音時間:</span> {{ this.recordData?.data?.totalTime ?? '' }}
          </span>
          <mat-icon class="gost-timeline-card__chevron" [class.gost-timeline-card__chevron--expanded]="gostTimelineExpanded">
            expand_more
          </mat-icon>
        </div>
      </button>

      @if (gostTimelineExpanded) {
        <div id="gost-timeline-content" class="gost-timeline-card__grid">
          <div class="gost-timeline-card__wave">
            <app-measured-data-wave-card
              [frameless]="true"
              [showMiniPlayback]="true"
              [recordData]="recordData"
              [recordtype]="recordtype"
              [recordLoadingSuccess]="recordLoadingSuccess"
              [waveLoadingPercent]="waveLoadingPercent"
              [waveErrorMessage]="waveErrorMessage"
              [selectedEvent]="selectedEvent"
              [currentStartOffset]="currentStartOffset"
              [playing]="playing"
              [timelineOffsetReference]="timelineOffsetReference"
              [zoomValue]="zoomValue"
              [avSyncFrontTrimRatio]="avSyncFrontTrimRatio"
              [avSyncEndTrimRatio]="avSyncEndTrimRatio"
              (offsetToggle)="offsetChanged($event)"
              (seek)="seekTo($event)"
              (playPauseClicked)="playPause()"
              (zoomMinusClicked)="zoomMinus()"
              (zoomResetClicked)="zoomReset()"
              (zoomPlusClicked)="zoomPlus()">
            </app-measured-data-wave-card>
          </div>

          <div class="gost-timeline-card__posture">
            <app-measured-data-neck-angle-card
              [frameless]="true"
              [chartOption]="chartOption"
              [currentChartOption]="currentChartOption"
              [currentOrientation]="currentNeckOrientation"
              (chartInit)="onNeckAngleChartInit($event)"
              (currentChartInit)="onCurrentNeckAngleChartInit($event)">
            </app-measured-data-neck-angle-card>
          </div>

          <div class="gost-timeline-card__events">
            <app-event-table
              [events]="parsedMeasurement?.events ?? []"
              (seekToEvent)="seekToEvent($event)">
            </app-event-table>
          </div>

          <div class="gost-timeline-card__footer">
            <app-data-footer
              [dataId]="this.recordData?.id ?? ''"
              [nbModel]="this.recordData?.data?.nbModel ?? ''"
              [downloadUrl]="this.recordData?.data?.storage?.data ?? ''">
            </app-data-footer>
          </div>
        </div>
      }
    </div>
  </ng-template>

  <div class="cards-container">
    @if (recordtype == 0 && showRsstChart && this.recordData) {
      <!-- RSST Protocol -->
      <app-protocol-rsst
        class="card-wide"
        [recordData]="this.recordData"
        [parsedMeasurement]="parsedMeasurement"
        [pieChartData]="pieChartData"
        [pieChartColor]="pieChartColor"
        [recordtype]="recordtype"
        [recordLoadingSuccess]="recordLoadingSuccess"
        [waveLoadingPercent]="waveLoadingPercent"
        [waveProcessing]="waveProcessing"
        [waveDownloading]="waveDownloading"
        [waveDownloadPercent]="waveDownloadPercent"
        [waveErrorMessage]="waveErrorMessage"
        [selectedEvent]="selectedEvent"
        [currentStartOffset]="currentStartOffset"
        [playing]="playing"
        [timelineOffsetReference]="timelineOffsetReference"
        [zoomValue]="zoomValue"
        [showWaveCard]="showWaveCard"
        [chartOption]="chartOption"
        [currentChartOption]="currentChartOption"
        [currentOrientation]="currentNeckOrientation"
        (offsetToggle)="offsetChanged($event)"
        (seek)="seekTo($event)"
        (eventSeek)="seekToEvent($event)"
        (playPauseClicked)="playPause()"
        (zoomMinusClicked)="zoomMinus()"
        (zoomResetClicked)="zoomReset()"
        (zoomPlusClicked)="zoomPlus()"
        (waveHostReady)="onWaveHostFromVideo($event)"
        (chartInit)="onNeckAngleChartInit($event)"
        (currentChartInit)="onCurrentNeckAngleChartInit($event)">
      </app-protocol-rsst>
    }
    @if (showMwstView && this.recordData) {
      <!-- MWST Protocol -->
      <app-protocol-mwst
        class="card-wide"
        [recordData]="this.recordData"
        [parsedMeasurement]="parsedMeasurement"
        [recordtype]="recordtype"
        [recordLoadingSuccess]="recordLoadingSuccess"
        [waveLoadingPercent]="waveLoadingPercent"
        [waveProcessing]="waveProcessing"
        [waveDownloading]="waveDownloading"
        [waveDownloadPercent]="waveDownloadPercent"
        [waveErrorMessage]="waveErrorMessage"
        [selectedEvent]="selectedEvent"
        [currentStartOffset]="currentStartOffset"
        [playing]="playing"
        [timelineOffsetReference]="timelineOffsetReference"
        [zoomValue]="zoomValue"
        [showWaveCard]="showWaveCard"
        [chartOption]="chartOption"
        [currentChartOption]="currentChartOption"
        [currentOrientation]="currentNeckOrientation"
        (offsetToggle)="offsetChanged($event)"
        (seek)="seekTo($event)"
        (eventSeek)="seekToEvent($event)"
        (playPauseClicked)="playPause()"
        (zoomMinusClicked)="zoomMinus()"
        (zoomResetClicked)="zoomReset()"
        (zoomPlusClicked)="zoomPlus()"
        (waveHostReady)="onWaveHostFromVideo($event)"
        (chartInit)="onNeckAngleChartInit($event)"
        (currentChartInit)="onCurrentNeckAngleChartInit($event)">
      </app-protocol-mwst>
    }

    @if (showMonitoringView && this.recordData) {
      <!-- Monitoring Protocol -->
      <app-protocol-monitoring
        class="card-wide"
        [recordData]="this.recordData"
        [parsedMeasurement]="parsedMeasurement"
        [beforeMealImage]="beforeMealImage"
        [afterMealImage]="afterMealImage"
        [recordtype]="recordtype"
        [recordLoadingSuccess]="recordLoadingSuccess"
        [waveLoadingPercent]="waveLoadingPercent"
        [waveProcessing]="waveProcessing"
        [waveDownloading]="waveDownloading"
        [waveDownloadPercent]="waveDownloadPercent"
        [waveErrorMessage]="waveErrorMessage"
        [selectedEvent]="selectedEvent"
        [currentStartOffset]="currentStartOffset"
        [playing]="playing"
        [timelineOffsetReference]="timelineOffsetReference"
        [zoomValue]="zoomValue"
        [showWaveCard]="showWaveCard"
        [chartOption]="chartOption"
        [currentChartOption]="currentChartOption"
        [currentOrientation]="currentNeckOrientation"
        (offsetToggle)="offsetChanged($event)"
        (seek)="seekTo($event)"
        (eventSeek)="seekToEvent($event)"
        (playPauseClicked)="playPause()"
        (zoomMinusClicked)="zoomMinus()"
        (zoomResetClicked)="zoomReset()"
        (zoomPlusClicked)="zoomPlus()"
        (waveHostReady)="onWaveHostFromVideo($event)"
        (chartInit)="onNeckAngleChartInit($event)"
        (currentChartInit)="onCurrentNeckAngleChartInit($event)">
      </app-protocol-monitoring>
    }

    @if (recordtype == 1 && this.recordData) {
      <div class="card-row">
        <vital-recording-card #vital_recording_card [recordData]="this.recordData"></vital-recording-card>
      </div>
    }

    @if (recordtype == 2 && this.recordData) {
      <gost-recording-card
        class="card-wide"
        #gost_recording_card
        [recordData]="this.recordData">
      </gost-recording-card>
    }



    @if (this.recordData && isMwstFoodTestRecord() && !showMwstView) {
      <div class="card-row">
        <mwstftg-recording-card
          class="card-wide"
          #mwsftg_recording_card
          [recordData]="this.recordData">
        </mwstftg-recording-card>
      </div>
    }

    @if (recordtype == -2 && this.recordData) {
      <div class="card-row">
        <no-recording-card #no_recording_card></no-recording-card>
      </div>
    }

    @if ((recordtype == 4 || recordData?.data?.recordType === 'VS') && recordData) {
      <!-- VS Protocol -->
      <app-protocol-vs
        class="card-wide"
        [recordData]="this.recordData"
        [mediaRecordData]="this.mediaRecordData ?? vsMediaFallbackData ?? (mediaLoadFailed ? mediaErrorFallbackData : null)"
        [parsedMeasurement]="parsedMeasurement"
        [playerSnapshot]="playerController.snapshot()"
        [playbackEnded]="playbackEnded"
        [audioMutedOverride]="vsAudioMutedForDisplay"
        [recordtype]="recordtype"
        [recordLoadingSuccess]="recordLoadingSuccess"
        [waveLoadingPercent]="waveLoadingPercent"
        [waveProcessing]="waveProcessing"
        [waveDownloading]="waveDownloading"
        [waveDownloadPercent]="waveDownloadPercent"
        [waveErrorMessage]="waveErrorMessage"
        [selectedEvent]="selectedEvent"
        [currentStartOffset]="currentStartOffset"
        [playing]="playing"
        [timelineOffsetReference]="timelineOffsetReference"
        [zoomValue]="zoomValue"
        [showWaveCard]="showWaveCard"
        [chartOption]="chartOption"
        [currentChartOption]="currentChartOption"
        [currentOrientation]="currentNeckOrientation"
        [avSyncFrontTrimRatio]="avSyncFrontTrimRatio"
        [avSyncEndTrimRatio]="avSyncEndTrimRatio"
        (offsetToggle)="offsetChanged($event)"
        (seek)="seekTo($event)"
        (eventSeek)="seekToEvent($event)"
        (playPauseClicked)="playPause()"
        (zoomMinusClicked)="zoomMinus()"
        (zoomResetClicked)="zoomReset()"
        (zoomPlusClicked)="zoomPlus()"
        (waveHostReady)="onWaveHostFromVideo($event)"
        (chartInit)="onNeckAngleChartInit($event)"
        (currentChartInit)="onCurrentNeckAngleChartInit($event)"
        (videoHostReady)="onVideoHostReady($event)"
        (videoPlayToggle)="onVideoPlayToggle()"
        (videoSeekTo)="onVideoSeekTo($event)"
        (videoRateChange)="onVideoRateChange($event)"
        (videoMuteToggle)="onVideoMuteToggle()">
      </app-protocol-vs>
    }

    @if (recordtype == 5 && this.recordData) {
      <!-- TOMASS Protocol -->
      <app-protocol-tomass
        class="card-wide"
        [recordData]="this.recordData"
        [parsedMeasurement]="parsedMeasurement"
        [recordtype]="recordtype"
        [recordLoadingSuccess]="recordLoadingSuccess"
        [waveLoadingPercent]="waveLoadingPercent"
        [waveProcessing]="waveProcessing"
        [waveDownloading]="waveDownloading"
        [waveDownloadPercent]="waveDownloadPercent"
        [waveErrorMessage]="waveErrorMessage"
        [selectedEvent]="selectedEvent"
        [currentStartOffset]="currentStartOffset"
        [playing]="playing"
        [timelineOffsetReference]="timelineOffsetReference"
        [zoomValue]="zoomValue"
        [showWaveCard]="showWaveCard"
        [chartOption]="chartOption"
        [currentChartOption]="currentChartOption"
        [currentOrientation]="currentNeckOrientation"
        (offsetToggle)="offsetChanged($event)"
        (seek)="seekTo($event)"
        (eventSeek)="seekToEvent($event)"
        (playPauseClicked)="playPause()"
        (zoomMinusClicked)="zoomMinus()"
        (zoomResetClicked)="zoomReset()"
        (zoomPlusClicked)="zoomPlus()"
        (waveHostReady)="onWaveHostFromVideo($event)"
        (chartInit)="onNeckAngleChartInit($event)"
        (currentChartInit)="onCurrentNeckAngleChartInit($event)">
      </app-protocol-tomass>
    }

    @if (recordtype == 6 && this.recordData) {
      <!-- SSTP Protocol -->
      <app-protocol-sstp
        class="card-wide"
        [recordData]="this.recordData"
        [parsedMeasurement]="parsedMeasurement"
        [recordtype]="recordtype"
        [recordLoadingSuccess]="recordLoadingSuccess"
        [waveLoadingPercent]="waveLoadingPercent"
        [waveProcessing]="waveProcessing"
        [waveDownloading]="waveDownloading"
        [waveDownloadPercent]="waveDownloadPercent"
        [waveErrorMessage]="waveErrorMessage"
        [selectedEvent]="selectedEvent"
        [currentStartOffset]="currentStartOffset"
        [playing]="playing"
        [timelineOffsetReference]="timelineOffsetReference"
        [zoomValue]="zoomValue"
        [showWaveCard]="showWaveCard"
        [chartOption]="chartOption"
        [currentChartOption]="currentChartOption"
        [currentOrientation]="currentNeckOrientation"
        (offsetToggle)="offsetChanged($event)"
        (seek)="seekTo($event)"
        (eventSeek)="seekToEvent($event)"
        (playPauseClicked)="playPause()"
        (zoomMinusClicked)="zoomMinus()"
        (zoomResetClicked)="zoomReset()"
        (zoomPlusClicked)="zoomPlus()"
        (waveHostReady)="onWaveHostFromVideo($event)"
        (chartInit)="onNeckAngleChartInit($event)"
        (currentChartInit)="onCurrentNeckAngleChartInit($event)">
      </app-protocol-sstp>
    }

    @if (recordtype >= 0 && showWaveCard && recordtype != 4 && recordData?.data?.recordType !== 'VS' && !(recordtype == 0 && showRsstChart) && !showMwstView && !showMonitoringView && recordtype !== 5 && recordtype !== 6 && recordtype !== 7) {
      <app-measured-data-wave-card
        class="card-wide"
        [recordData]="recordData"
        [recordtype]="recordtype"
        [recordLoadingSuccess]="recordLoadingSuccess"
        [waveLoadingPercent]="waveLoadingPercent"
        [waveErrorMessage]="waveErrorMessage"
        [selectedEvent]="selectedEvent"
        [currentStartOffset]="currentStartOffset"
        [playing]="playing"
        [timelineOffsetReference]="timelineOffsetReference"
        [zoomValue]="zoomValue"
        [videoMuted]="videoMuted"
        [avSyncFrontTrimRatio]="avSyncFrontTrimRatio"
        [avSyncEndTrimRatio]="avSyncEndTrimRatio"
        (offsetToggle)="offsetChanged($event)"
        (seek)="seekTo($event)"
        (playPauseClicked)="playPause()"
        (zoomMinusClicked)="zoomMinus()"
        (zoomResetClicked)="zoomReset()"
        (zoomPlusClicked)="zoomPlus()">
      </app-measured-data-wave-card>
    }

    <div class="card-container">
      @if (recordtype >= 0 && this.recordData?.id !== 'new_gost' && !(recordtype == 7 && this.recordData?.data?.totalTime == '00:00:00') &&
        this.recordData && !(recordtype == 0 && showRsstChart) && !showMwstView && !showMonitoringView && !(recordtype == 4 || recordData?.data?.recordType === 'VS') && recordtype !== 5 && recordtype !== 6 && recordtype !== 7) {
        <app-measured-data-neck-angle-card
          [chartOption]="chartOption"
          [currentChartOption]="currentChartOption"
          [currentOrientation]="currentNeckOrientation"
          (chartInit)="onNeckAngleChartInit($event)"
          (currentChartInit)="onCurrentNeckAngleChartInit($event)">
        </app-measured-data-neck-angle-card>
      }

    </div>
  </div>
</div>
